<div class="home-page-column flex w-[430px] shrink-0 flex-col justify-start gap-5 border-r-2 border-[lightgray] px-5">
  <h1 class="greeting -mb-5">&nbsp;</h1>
  <a
    class="min-h-36 !justify-start !px-8"
    mat-raised-button
    routerLink="/payroll"
    id="LogRocket-HomePage-BigTileApprovePayroll"
    [queryParams]="currentQueryParams"
  >
    <span class="flex flex-row items-center justify-start gap-4">
      <img class="mt-8" ngSrc="assets/images/home-payroll.png" height="96" width="96" alt="" priority />
      <span class="text-3xl">Approve Payroll</span>
    </span>
  </a>

  <a
    class="min-h-36 !justify-start !px-8"
    mat-raised-button
    routerLink="/billing"
    id="LogRocket-HomePage-BigTileApproveBilling"
    [queryParams]="currentQueryParams"
  >
    <span class="flex flex-row items-center justify-start gap-4">
      <img ngSrc="assets/images/home-billing.png" height="96" width="96" alt="" priority />
      <span class="text-3xl">Approve Billing</span>
    </span>
  </a>

  <a
    class="min-h-36 !justify-start !px-8"
    mat-raised-button
    routerLink="/timesheetmanager"
    id="LogRocket-HomePage-BigTileTimesheets"
    [queryParams]="currentQueryParams"
  >
    <span class="flex flex-row items-center justify-start gap-4">
      <img ngSrc="assets/images/home-magnifying-glass.png" height="96" width="96" alt="" priority />
      <span class="text-3xl">Timesheets</span>
    </span>
  </a>
</div>
<div class="home-page-column flex w-full flex-col">
  @if (homePageLoaded$ | async) {
    <h1 class="greeting">Hello, {{ name }}</h1>
    <div class="flex justify-evenly gap-10 px-10">
      <div class="tile-column-container mat-elevation-z2">
        <div class="tile-column-title">Payroll</div>
        <div class="tile-column">
          @if (payrollColumn?.length > 0) {
            @for (row of payrollColumn; track $index) {
              <a class="tile" mat-raised-button routerLink="/payroll" [queryParams]="row.queryParams">
                <div class="flex items-center justify-center gap-2 text-left">
                  <img ngSrc="assets/images/home-payroll.png" height="48" width="48" class="mt-4" alt="" loading="lazy" />
                  <span>
                    {{ row.display }}
                  </span>
                </div>
              </a>
            }
          } @else {
            <div class="flex flex-col pt-12">
              <div class="flex items-center justify-center gap-4">
                <img class="w-24" ngSrc="assets/images/home-thumbs-up.png" height="96" width="96" alt="" loading="lazy" />
                <span class="text-3xl">All Caught Up!</span>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="tile-column-container mat-elevation-z2">
        <div class="tile-column-title">Billing</div>
        <div class="tile-column">
          @if (billingColumn?.length > 0) {
            @for (row of billingColumn; track $index) {
              <a
                class="tile items-center justify-start"
                mat-raised-button
                routerLink="/billing/review"
                matTooltipPosition="left"
                matTooltip="Contains unapproved payroll hours"
                [class.contains-unapproved]="row.hasPayrollDependency"
                [queryParams]="row.queryParams"
                [matTooltipDisabled]="!row.hasPayrollDependency"
              >
                <div class="flex items-center justify-start gap-2">
                  <img ngSrc="assets/images/home-billing.png" height="48" width="48" alt="" loading="lazy" />
                  <div class="flex flex-col items-start justify-start overflow-hidden text-left">
                    <span class="w-full">{{ row.custGrp }}</span>
                    <span class="w-full overflow-hidden text-ellipsis">{{ row.display }}</span>
                  </div>
                </div>
              </a>
            }
          } @else {
            <div class="flex flex-col pt-12">
              <div class="flex items-center justify-center gap-4">
                <img class="w-24" ngSrc="assets/images/home-thumbs-up.png" height="96" width="96" alt="" loading="lazy" />
                <span class="text-3xl">All Caught Up!</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="flex h-full w-full items-center justify-center">
      <mat-spinner />
    </div>
  }
</div>
